export default {"src":"/_next/static/media/alignment_filled.1e9325ab.svg","height":24,"width":24};